import { render, staticRenderFns } from "./mobile_report.vue?vue&type=template&id=70af2486&scoped=true&"
import script from "./mobile_report.vue?vue&type=script&lang=js&"
export * from "./mobile_report.vue?vue&type=script&lang=js&"
import style0 from "./mobile_report.vue?vue&type=style&index=0&id=70af2486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af2486",
  null
  
)

export default component.exports